import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ca-confirmation-dialog',
  template: `
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content>{{ body }}</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button
    [color]="confirmColor"
    (click)="confirmAction()" mat-dialog-close>{{ confirm }}</button>
    <button mat-button
    (click)="cancelAction()" mat-dialog-close>{{ cancel }}</button>
  </mat-dialog-actions>
    `
})
export class ConfirmationDialogComponent {
  title = 'Are you sure?';
  body = 'Please confirm your choice.';
  confirm = 'Yes';
  cancel = 'Cancel';
  confirmColor;

  constructor(
    private ref: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    for (const key in data) {
      if (data[key]) {
        this[key] = data[key];
      }
    }
  }

  confirmAction() {
    this.ref.close(true);
  }

  cancelAction() {
    this.ref.close();
  }
}
